import React from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Button.module.scss';
const Button = ({
  classname,
  label,
  href,
  target,
  rel,
  icon,
  type,
  disabled,
  variant = 'primary',
  onClick,
  external
}) => {
  let Component = 'span';
  if (type) {
    Component = 'button';
  } else if (href) {
    Component = 'a';
  }
  const targetBlank = external ? {
    target: '_blank',
    rel: 'nofollow noopener noreferrer'
  } : {};
  return /*#__PURE__*/React.createElement(Component, Object.assign({
    onClick: onClick,
    disabled: type && disabled,
    target: target,
    rel: rel,
    className: `${styles.root} ${styles[variant]} ${classname || ''} ${icon ? styles['icon'] : ''} `,
    href: href,
    type: type
  }, targetBlank), label, icon && /*#__PURE__*/React.createElement(Icon, {
    classname: styles.rootButtonIcon,
    name: icon
  }));
};
export default Button;